<template>
  <div class="add-project-pop-w">
    <div class="project-pop-card">
      <div class="title-w">
        <div class="title">Create New Project</div>
        <div class="close-pop"><i class="el-icon-close" @click="$emit('close-pop')"></i></div>
      </div>
      <div class="question"> What's your project's <span style="font-weight: bold">name</span>? </div>
      <div class="no-valid-tip" v-show="invalidProjectName">Only character, number, space and _ are accepted</div>
      <div class="project-id" v-show="projectId !== '' && !invalidProjectName">
        <span>Tips: </span>
        <strong>{{projectId}}</strong>
        <span v-show="!dupicatedProjectId"> will be your project ID</span>
        <span v-show="dupicatedProjectId" style="color: red;"> already exist</span>
      </div>
      <el-input placeholder="Project Name Here" v-model="projectInfo.name"></el-input>
      <el-alert
        v-if="submitError"
        :title="submitError"
        type="error">
      </el-alert>
      <div style="text-align: center; margin-top: 16px">
        <el-button size="large" type="primary" round @click="submitProject()" :disabled="!canSubmit" style="margin-top: 16px; margin-bottom: 12px">Create</el-button>
      </div>
      <div class="input-error">{{inputError.name}}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AddProjectPop',
  data () {
    return {
      projectInfo: {
        name: ''
      },
      inputError: {
        name: ''
      },
      submitError: ''
    }
  },
  computed: {
    projectId: function () {
      let projectName = this.projectInfo.name
      let removeTrailingSpace = /\s*$/g
      let removeSpace = /\s+/g
      let projectId = projectName.replace(removeTrailingSpace, '').replace(removeSpace, '-').toLowerCase()
      return projectId
    },
    existProjectIds: function () {
      return this.$store.state.projects.map(project => { return project.id })
    },
    dupicatedProjectId: function () {
      return this.existProjectIds.includes(this.projectId)
    },
    invalidProjectName: function () {
      return this.projectInfo.name.match(/^[\w\s]*$/) === null
    },
    canSubmit: function () {
      return !this.dupicatedProjectId && !this.invalidProjectName && this.projectId !== ''
    }
  },
  methods: {
    submitProject: async function () {
      if (!this.canSubmit) {
        return
      }
      let projectData = {
        createOn: Date.now(),
        lastOpenOn: Date.now(),
        name: this.projectInfo.name,
        id: this.projectId,
        open: true
      }
      let addResult = await this.$store.dispatch('addProject', projectData)
      if (addResult.success) {
        this.$message.success('New Project Added!')
        this.$emit('close-pop')
      } else {
        this.submitError = addResult.error
      }
    }
  }
}
</script>

<style>
.project-pop-card {
  border-radius: 20px;
  box-sizing: border-box;
  padding: 24px;
  background-color: #ffffff;
}
.project-id {
  margin-bottom: 6px;
  font-size: 16px;
  line-height: 24px;
}
.title-w {
  display: flex;
  justify-content: space-between;
}
.title {
  font-size: 24px;
  line-height: 48px;
  font-weight: 600;
  margin-bottom: 20px;
}
.close-pop {
  width: 48px;
  height: 48px;
  box-sizing: border-box;
  padding: 15.5px;
  float: right;
  cursor: pointer;
}
.question {
  font-size: 18px;
  line-height: 27px;
  margin-bottom: 12px;
  font-weight: 600;
}
.input-error {
  color: #f31431;
  font-size: 16px;
  line-height: 24px;
  margin-top: 8px
}
</style>
